<template>
  <div class="card card-content">
    <div class="card-header">
      <breadcrumb :label="label"></breadcrumb>
      <h1>Ajouter un événement</h1>
      <div class="actions">
        <a class="btn btn-link" href="#" v-link="{path: '/contact/edit/' + contact.id}">Retour</a>
        <a class="btn btn-link" href="#" @click.prevent="save" >Sauvegarder</a>
      </div>
    </div>

    <div class="card-block">
      <meeting-form
        :data.sync          = "meeting"
        :users              = "users"
        :contacts           = "contacts"
        :contact            = "contact"
        :projects           = "projects"
        :project            = "project"
        :presences          = "presences"
        :phases             = "phases"
        :contents           = "contents"
        :trainings          = "trainings"
        :places             = "places"
        :firstintervenants  = "firstintervenants"
        :validation-rules   = "validationRules"
        :authenticated-user = "authenticatedUser"
      ></meeting-form>
    </div>
    <div class="card-footer">
      <div class="actions">
        <a class="btn btn-link" href="#" v-link="{path: '/contact/edit/' + contact.id}">Retour</a>
        <a class="btn btn-link" href="#" @click.prevent="save" >Sauvegarder</a>
      </div>
    </div>
  </div>
</template>

<script>
  // Node modules
  import moment from 'moment'
  import toastr from 'toastr'

  // Vuex
  import { users, presences, phases, contents, places, trainings, firstintervenants, meetingCreated, authenticatedUser, contacts, projects, contact, project } from 'src/vuex/getters'
  import { getUsers } from 'src/vuex/actions/userActions'
  import { addMeeting } from 'src/vuex/actions/meetingActions'
  import { getPresences } from 'src/vuex/actions/presenceActions'
  import { getPhases } from 'src/vuex/actions/phaseActions'
  import { getContents } from 'src/vuex/actions/contentActions'
  import { getTrainings } from 'src/vuex/actions/trainingActions'
  import { getPlaces } from 'src/vuex/actions/placeActions'
  import { getFirstintervenants } from 'src/vuex/actions/firstintervenantActions'
  import { getAuthenticatedUser } from 'src/vuex/actions/authActions'
  import { getContacts, getContact, getProjectsOfContact } from 'src/vuex/actions/contactActions'
  import { getProjects, getProject } from 'src/vuex/actions/projectActions'

  // Components
  import MeetingForm from 'src/components/meetings/MeetingForm'
  import Breadcrumb from '../nav/Breadcrumb.vue'

  // Validation
  import { add as validationRules } from 'src/validations/meetings'

  // Utils
  import { formatMeetingForDBInsertion as formatMeeting } from 'src/utils/fullcalendar'

  export default{
    vuex: {
      getters: { users, presences, phases, contents, trainings, meetingCreated, authenticatedUser, contacts, projects, contact, project, places, firstintervenants },
      actions: { getUsers, getPhases, getContents, getTrainings, getPresences, addMeeting, getAuthenticatedUser, getContacts, getProjects, getContact, getProject, getFirstintervenants, getPlaces, getProjectsOfContact }
    },
    watch: {
      'meetingCreated': function (value) {
        if (value === true) {
          toastr.success('Nouveau rdv ajouté')
          // this.$router.go('/')
          console.log('Rdv ajoute ' + this.meeting)
          this.$router.go('/contact/planning/' + this.contact.id)
        }
      }
    },
    methods: {
      save () {
        /*
        if (typeof (this.meeting.title) === 'undefined' || this.meeting.title === null || this.meeting.title === '' || this.meeting.title === 'undefined') {
          this.meeting.title = 'Sans titre'
        }
        */
        // console.log('meeting substitute ' + this.meeting.userId + '|' + this.meeting.firstintervenant_id + '?' + this.meeting.firstintervenantId + '#' + this.meeting.user + ':' + this.authenticatedUser.id)
        this.meeting.userId = this.meeting.firstintervenantId
        this.addMeeting(formatMeeting(this.meeting))
      }
    },
    components: {
      'meeting-form': MeetingForm, Breadcrumb
    },
    data () {
      return {
        meeting: {
          title: '',
          description: '',
          day: moment().format('DD-MM-YYYY'),
          endHour: '08',
          startHour: '07',
          endMinutes: '00',
          startMinutes: '00',
          duration: '',
          userId: this.authenticatedUser.id,
          presenceId: '',
          phaseId: '',
          contentId: '',
          trainingId: '',
          placeId: '',
          firstintervenantId: '',
          secondintervenantId: '',
          thirdintervenantId: '',
          contact_id: '',
          project_id: '',
          intervenantexterieur: ''
        },
        label: [['', 'Tableau de bord'], ['add', 'Ajouter un événement']],
        validationRules
      }
    },
    ready () {
      console.log('meetingAdd ' + this.$route.params.contactId + ' | ' + this.$route.params.projectId + ' | ' + this.authenticatedUser.id)
      if (this.$route.params.projectId !== undefined) {
        this.getProject(this.$route.params.projectId)
      }
      if (this.$route.params.contactId !== undefined) {
        this.getContact(this.$route.params.contactId)
          .then(() => {
            this.getUsers()
            this.getContacts()
            this.getPresences()
            this.getPhases()
            this.getContents()
            this.getTrainings()
            this.getPlaces()
            this.getFirstintervenants()
            this.meeting.userId = this.authenticatedUser.id
          })
      } else {
        this.getUsers()
        this.getContacts()
        this.getPresences()
        this.getPhases()
        this.getContents()
        this.getTrainings()
        this.getPlaces()
        this.getFirstintervenants()
        this.meeting.userId = this.authenticatedUser.id
        // this.contact = null # Error: vuex getter properties are read-only
      }
    }
  }
</script>

<style lang="scss">
  .cov-vue-date *{
    font-family: 'Droid Sans', sans-serif !important;
  }
</style>



// WEBPACK FOOTER //
// MeetingAdd.vue?42d2c39b